export const sideNavbar = {
  home: "首页",
  games: "游戏",
  allGames: "全部",
  lottery: "彩票",
  raffle: "抽奖",
  providers: "供应商",
  categories: "类别",
  casino: "Casino Live",
  casinos: "Casino Live",
  poker: "扑克",
  sports: "运动",
  allSports: "全部",
  allPageGames: "全部",
  soccer: "足球",
  baseball: "棒球",
  basketball: "篮球",
  e_sports: "电子竞技",
  nfl: "橄榄球",
  allPageSports: "所有",
  parleyMenu: "Parley",
  support: "支持",
  live_casino: "现场赌场",
  bingo: "宾果",
  horses: "赛马",
  hipism: "马术",
  News: "新闻",
  gameFeed: "游戏动态",
  miniJuegos: "迷你游戏",
  sidebarSectionMain: "主要",
  sidebarSectionGames: "游戏",
  sidebarSectionMore: "更多",
  sidebarSectionActions: "操作",
  sidebarMyFavorites: "我的收藏",
};